import { toast } from "react-toastify";
import React, { useState } from "react";
import { Grid, Message, Button } from "semantic-ui-react";
import { AutoForm, AutoField } from "uniforms-semantic";
import { ToastWrapper } from "../../components/wrapper/Toastwrapper";
import forgetPasswordMutate from "./utils/forgetPasswordMutate";
import { cleanUpAndValidateEmail } from "/imports/utils/functions/fnCleanupEmail";
import { initJSONschema } from "/imports/utils/UI/initJSONschema";
import { RegEx } from "/imports/api/_jsonSchemas/schemas/components/_all";

import Debug from "debug";
const debug = Debug("forgot");

const schema = initJSONschema({
  type: "object",
  properties: {
    email: {
      type: "string",
      pattern: RegEx.Email.source
    }
  }
});

const Forgot = () => {
  const [disableForm, setDisabled] = useState(false);
  const [done, setDone] = useState();

  async function onSubmitForm({ email }) {
    setDisabled(true);
    try {
      await forgetPasswordMutate({ email: cleanUpAndValidateEmail(email) });
      return setDone(true);
    } catch (e) {
      setDisabled(false);
      debug("forgetPasswordMutate", e);
      return toast.error(
        <ToastWrapper>
          <b>Password reset error</b>
          <br />
          {!(e instanceof Error) ? `${e.message}`: "Something went wrong please try again"}
        </ToastWrapper>
      );
    }
  }
  return (
    <AutoForm className="ui inverted form forgot-password" schema={schema} onSubmit={onSubmitForm}>
      <img className="ui medium image logo" src="/images/logo-transmate.svg" alt="logo" />
      {done ? (
        <>
          <Message content="We've sent you an email with a link to reset your password." />
          <a href="/sign-in">Back to sign in page.</a>
        </>
      ) : (
        <>
          <AutoField
            type="email"
            name="email"
            autoComplete="username"
            label="Email"
            disabled={disableForm}
          />
          <Grid columns={2}>
            <Grid.Column>
              <Button type="submit" primary content="Reset password" disabled={disableForm} />
            </Grid.Column>
            <Grid.Column>
              <a href="/sign-in">Or sign in</a>
            </Grid.Column>
          </Grid>
        </>
      )}
    </AutoForm>
  );
};

export default Forgot;
